import { Dialog, makeStyles } from "@material-ui/core";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useWindowResize } from "utils/hooks";

const useStyles = makeStyles({
	scrollPaper: {
		display: "block !important",
	},
	scrollPaperDesktop: {
		alignItems: "unset",
	},
	dialog: {
		width: "350px",
		height: "180px",
		position: "relative",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: "8px",
		margin: 0,
		boxShadow: "none",
		background: "none",
		top: "240px",
		left: "-80px",
		"@media (max-width: 1000px)": {
			left: "-50px",
		},
		"@media (max-width: 950px)": {
			left: "-40px",
		},
		"@media (max-width: 900px)": {
			left: "0px",
		},
		"@media (max-width: 850px)": {
			left: "40px",
		},
		"@media (max-width: 800px)": {
			left: "65px",
		},
		"@media (max-width: 750px)": {
			left: "90px",
		},
	},
	dialogMobile: {
		width: "350px",
		height: "180px",
		position: "absolute",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: "8px",
		margin: 0,
		boxShadow: "none",
		background: "none",
		top: "250px",
		left: "50%",
		transform: "translateX(-50%)",
	},
});

const PreAppliedFilterCoachMark = ({ isOpen, handleClose }) => {
	const classes = useStyles();
	const [isMobileView] = useWindowResize();

	useEffect(() => {
		if (isOpen) {
			document.body.style.overflow = "hidden";
			document.body.style.position = "fixed";
			document.body.style.width = "100%";
		} else {
			document.body.style.position = "unset";
			document.body.style.overflow = "unset";
			document.body.style.width = "auto";
		}

		return () => {
			document.body.style.position = "unset";
			document.body.style.overflow = "unset";
			document.body.style.width = "auto";
		};
	}, [isOpen]);

	return (
		<Dialog
			open={isOpen}
			classes={{
				paper: isMobileView ? classes.dialogMobile : classes.dialog,
				scrollPaper: isMobileView
					? classes.scrollPaper
					: classes.scrollPaperDesktop,
			}}
			disableScrollLock
		>
			<div className="h-0 w-0 rotate-90 border-b-[12px] border-r-[12px] border-t-[12px] border-b-transparent border-r-[#fff] border-t-[transparent] sm:left-[50%] md:absolute md:left-[3px] md:rotate-0" />
			<div className="mt-[-6px] flex h-[144px] w-[320px] flex-col items-center justify-center gap-[16px] rounded-[4px] bg-[#fff] p-[16px] md:mt-0">
				<div className="mx-auto">
					<p className="m-0 p-0 text-left text-[14px] font-[600] leading-[20px]">
						Filtered jobs based on your profile 🎯
					</p>
					<p className="m-0 mt-[8px] p-0 text-[12px] font-[400] leading-[16px] text-[#8C8594]">
						We have pre-selected filters to ensure you see the best matched
						jobs, helping you find the perfect fit{" "}
					</p>
				</div>
				<button
					type="button"
					className="flex h-[36px] w-[288px] items-center justify-center rounded-[4px] border-[1px] bg-[#1F8268] px-[16px] py-[16px] text-[14px] font-[600] leading-[20px] text-[#fff]"
					onClick={handleClose}
				>
					Got it
				</button>
			</div>
		</Dialog>
	);
};

export default PreAppliedFilterCoachMark;
